const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20sci-fi%20movie%20scene%20with%20futuristic%20cityscape%20and%20spaceship%2C%20cool%20blue%20and%20warm%20orange%20lighting%20contrast%2C%20cinematic%20wide%20shot%2C%20epic%20scale%2C%20professional%20film%20photography%2C%20clean%20composition%2C%20no%20text&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '科幻巨制',
    title: '《星际征途：新纪元》——年度科幻大片抢先看',
    desc: '视觉震撼与深度剧情兼得，探索人类在宇宙中的终极命运，特效制作达到好莱坞顶级水准。',
    meta: '4K · 中英双字',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20in%20cozy%20cafe%20with%20warm%20sunlight%2C%20two%20characters%20sharing%20intimate%20moment%2C%20soft%20pastel%20color%20palette%2C%20beautiful%20cinematography%2C%20emotional%20atmosphere%2C%20no%20text&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '韩剧热播',
    title: '《首尔之恋》甜蜜上线，治愈系爱情剧俘获千万观众',
    desc: '高颜值主演阵容搭配细腻情感刻画，每一帧都如画报般唯美动人。',
    meta: '1080P · 中文字幕',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Crime%20investigation%20TV%20drama%20scene%20in%20dimly%20lit%20police%20office%2C%20detectives%20studying%20evidence%20board%2C%20tense%20noir%20atmosphere%2C%20warm%20desk%20lamp%20lighting%2C%20professional%20film%20photography%2C%20moody%20tones%2C%20no%20text&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '国产悬疑',
    title: '《暗夜追踪》破案神剧回归，烧脑程度全面升级',
    desc: '豆瓣9.2分悬疑佳作续作，案件层层反转，细节伏笔令人拍案叫绝。',
    meta: '4K · 国语中字',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Animated%20film%20scene%20with%20colorful%20fantasy%20world%2C%20magical%20creatures%20in%20vibrant%20forest%2C%20bright%20and%20playful%20atmosphere%2C%20Pixar-style%20animation%20aesthetic%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20no%20text&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '动画佳作',
    title: '《幻境奇缘》动画电影口碑爆棚，全年龄段观影首选',
    desc: '精美画面与温暖故事完美融合，带孩子一起感受奇幻冒险的魅力。',
    meta: '1080P · 国语配音',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20colorful%20lights%20and%20performers%2C%20energetic%20live%20entertainment%20atmosphere%2C%20dynamic%20stage%20design%2C%20warm%20spotlight%20and%20vibrant%20LED%20screens%2C%20professional%20broadcast%20photography%2C%20no%20text&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '综艺精选',
    title: '《声动亚洲》音乐竞演综艺开播，神仙打架名场面不断',
    desc: '顶级歌手同台竞技，每一期都是视听盛宴，弹幕刷屏停不下来。',
    meta: '1080P · 中文配音',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            精选推荐
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 cursor-pointer ${
                idx === 0 ? 'lg:col-span-2 lg:flex' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'lg:w-2/5 lg:shrink-0' : ''}`}>
                <img
                  src={card.image}
                  alt={card.title}
                  className={`w-full object-cover group-hover:scale-105 transition-transform duration-500 ${
                    idx === 0 ? 'lg:h-full aspect-video lg:aspect-auto' : 'aspect-video'
                  }`}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col justify-center">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-foreground-500 text-sm mt-2 line-clamp-3">{card.desc}</p>
                <span className="inline-block mt-3 text-xs font-medium text-foreground-400 bg-background-100 px-2.5 py-1 rounded-full">
                  {card.meta}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}